import SubScriptionManagerBase from "./subscriptionmanagerbase";
//import {getPromospot} from './../../../common/utilities/apiRequest';

// this class will implement al the necessary API communication
// and cookie management to authenticate users and authorize
// downloads. It does not implement any UI elements.
export default class SubScriptionManagerFree extends SubScriptionManagerBase {
  // Returns the current authentication state.
  get isAuthenticated() {
    return true;
  }

  // irrelevant for the SSO subscriptionmanager, will reject always
  authenticateByUserNamePassword() {
    return Promise.resolve(true);
  }

  // returns a promise that will either reject with an error code when authentication
  // fails, either resolves to success. This is to be used in case of SSO, or
  // to check if you are autenticated
  // in any case it will also trigger the authenticationstatuschanged event if
  // the current status changed.
  authenticate() {
    return Promise.resolve(true);
  }

  /**
   * As for free subscription we don't need authorization, it just returns
   * resolved promise. Moreover, it creates reader sesssion cookie - this is needed
   * for generating secure links -> see utils.generateSecurePreviewURL and
   * utils.generateSecureImageURL
   * @return {Promise}
   */
  authorize() {
    this._setReaderSession();
    return Promise.resolve(true);
  }

  // returns a promise that will either reject with an error code when authorization
  // fails, either resolves to success. It will tagke as the assumption that
  // the CP and Publication is authorized and only uses the pageId for freemium
  // and metered model implementations
  authorizePage() {
    return Promise.resolve(true);
  }

  authorizeArticle() {
    return true;
  }

  _setReaderSession() {
    const { DownloadId, SessionId, UserId } =
      this._sessionManager.session.SessionInfo;
    const info = {
      userId: UserId,
      sessionId: SessionId,
      downloadId: DownloadId,
    };

    this._cookieManager.createCookie(
      this._cookieManager.cookieKeys.READER_SESSION,
      JSON.stringify(info),
      {
        path: "/",
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/subscriptionmanagement/subscriptionmanagerfree.js